/* eslint-disable no-magic-numbers */

// export const OVERHANG_LEFT = 2;
// export const OVERHANG_RIGHT = 2;
// export const OVERHANG_FRONT = 2;
// export const OVERHANG_BACK = 2;
// export const OVERHANG_MINIMUM_TO_SUPPORT_CORNERS = 0.5;
// export const COUNTERTOP_DEFAULT_OVERHANG = 2;
// export const COUNTERTOP_DEFAULT_OVERHANG_BAR_ISLAND = 10;
// export const COUNTERTOP_DEFAULT_THICKNESS = 1.25;
// export const COUNTERTOP_MIN_THICKNESS = 1.0;
// export const COUNTERTOP_MAX_THICKNESS = 3.0;

// export const SURROUND_MATERIAL_THICKNESS = {
// 	brick: 1.25,
// 	concrete: 0.75,
// 	shiplap: 0.75,
// 	stone: 1.5,
// 	wood: 0.75
// };

export const X_BASE_SIZE_ASADO_STAND = 30;
export const Y_BASE_SIZE_ASADO_STAND = 16;
export const Z_BASE_SIZE_ASADO_STAND = 28;

export const X_BASE_SIZE_PIZZA_STAND = 34;
export const Y_BASE_SIZE_PIZZA_STAND = 37;
export const Z_BASE_SIZE_PIZZA_STAND = 28;

export const Y_BASE_SIZE = 34.5;
export const Z_BASE_SIZE = 28.0;
// export const Z_BASE_CORNER_SIZE = 26.5;

export const Y_COUNTER_BASE_SIZE = 39.25;
export const Z_COUNTER_BASE_SIZE = 28.0;

// export const CORNERS = 0;
// export const CORNER_THICKNESS = 0.5;
// export const CORNER_WIDTH = 2.5;
export const BAR_OVERLAP = 30;
export const GRILL_ISLAND_DEPTH_DELTA = 4;

// the clear walkway a galley leaves between the two mating FRONT faces, in inches:
// 48 -> 4.00 ft, 60 -> 5.00 ft, 72 -> 6.00 ft of standing room between the two runs.
// not connectIslands' 1" default -- that default is the butt joint two islands make
// side panel to side panel, which is what add_island's left/right attach produces.
export const GALLEY_WALKWAY_PADDING = 60;

// doesn't include countertop overhang
export const TOP_ONLY_APPLIANCE_SETBACK = 2.5;

export const COUNTERTOP_INDEX = -1;
export const FRONT_INDEX = 0;
export const LEFT_INDEX = 1;
export const BACK_INDEX = 2;
export const RIGHT_INDEX = 3;
